import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import OrdersMobile from "../mobile/ecommerce/OrdersMobile";
import CommandesEnLigne from "./CommandesEnLigne";
export default function ResponsiveCommandesEnLigne(props) { return useIsMobile() ? <OrdersMobile {...props} /> : <CommandesEnLigne {...props} />; }
